import { useEditCartItemActions } from '@/features/pos/components/OrderFinalization/contexts/EditCartItemProvider'
import { useFocusEffect } from '@react-navigation/native'
import { useCallback } from 'react'

export const useStopCartItemEditationOnUnfocus = (): void => {
    const { unset } = useEditCartItemActions()

    useFocusEffect(
        useCallback(() => {
            return unset
        }, [unset])
    )
}
